import React, { useEffect } from 'react';
import PageHero from './PageHero';
import DonationForm from './DonationForm';
import DonationFeatures from './DonationFeatures';
import ContactCTAStrip from './ContactCTAStrip';

const Donation = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="donation-page">
      <PageHero title="Donation" />
      <DonationForm />
      <DonationFeatures />
      <ContactCTAStrip />
    </div>
  );
};

export default Donation;
